export const COMPANY = {
  name: "MotorieRicambi",
  phone: "+39 350 921 1432",
  phoneRaw: "+393509211432",
  whatsappRaw: "393509211432",
  email: "info@blmeccanicamotori.com",
  warranty: "Garanzia 12 Mesi Inclusa",
  yearsExperience: 35,
};

export const NAV_LINKS = [
  { href: "#servizi", label: "Servizi" },
  { href: "#preventivo", label: "Preventivo" },
  { href: "#perche-noi", label: "Perché Noi" },
  { href: "#recensioni", label: "Recensioni" },
  { href: "#contatti", label: "Contatti" },
];

export const TIPI_RICAMBIO = [
  "Motore Completo",
  "Cambio Manuale",
  "Cambio Automatico",
  "Musata Completa",
  "Altro",
];

export const SERVICES = [
  {
    id: "motori",
    n: "01",
    title: "Motori Usati e Revisionati",
    desc: "Ampia selezione di motori testati e revisionati. Prestazioni ottimali garantite per ogni modello.",
    img: "https://images.unsplash.com/photo-1519752594763-2633d8d4ea29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxjYXIlMjBlbmdpbmUlMjBtZXRhbGxpYyUyMGNsb3NldXB8ZW58MHx8fHwxNzc5OTAzNzc0fDA&ixlib=rb-4.1.0&q=85",
    bullets: ["Banco prova certificato", "Garanzia 12 mesi", "Codici motore verificati"],
  },
  {
    id: "cambi",
    n: "02",
    title: "Cambi Manuali e Automatici",
    desc: "Trasmissioni di alta qualità, verificate su banco prova per assicurare innesti fluidi e durata nel tempo.",
    img: "https://images.pexels.com/photos/28721763/pexels-photo-28721763.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: ["Innesti fluidi", "Test sotto carico", "Compatibilità garantita"],
  },
  {
    id: "musate",
    n: "03",
    title: "Musate Complete",
    desc: "Kit frontali completi pronti per l'installazione. Componenti originali per un ripristino perfetto.",
    img: "https://images.pexels.com/photos/34337558/pexels-photo-34337558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: ["Componenti originali", "Imballaggio sicuro", "Spedizione tracciata"],
  },
];

export const PILLARS = [
  {
    icon: "ShieldCheck",
    title: "Qualità Garantita",
    desc: "Tutti i nostri ricambi sono rigorosamente testati e coperti da una garanzia completa di 12 mesi.",
  },
  {
    icon: "Wrench",
    title: "Affidabilità Tecnica",
    desc: "Componenti revisionati da esperti del settore con oltre 35 anni di esperienza automotive.",
  },
  {
    icon: "Truck",
    title: "Spedizioni Rapide",
    desc: "Consegne veloci e tracciabili in tutta Italia con imballaggi sicuri e protetti.",
  },
  {
    icon: "Headphones",
    title: "Supporto Professionale",
    desc: "Assistenza dedicata per aiutarti a identificare il ricambio esatto per il tuo veicolo.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Marco T.",
    initials: "MT",
    role: "Motore Completo",
    quote:
      "Ho acquistato un motore completo per la mia Audi. Qualità eccellente, arrivato in perfette condizioni e la garanzia di 12 mesi mi fa stare tranquillo. Montato e funziona come un orologio svizzero.",
  },
  {
    name: "Giuseppe R.",
    initials: "GR",
    role: "Cambio Manuale",
    quote:
      "Servizio di revisione del cambio manuale impeccabile. Innesti fluidi e silenziosi, sembra di guidare un'auto appena uscita dal concessionario. Complimenti ai tecnici per la professionalità.",
  },
  {
    name: "Alessandro F.",
    initials: "AF",
    role: "Musata Completa",
    quote:
      "Spedizione rapidissima! La musata completa era imballata con estrema cura. I pezzi originali erano perfetti e pronti per il montaggio. Consigliatissimo per chi cerca ricambi di carrozzeria.",
  },
  {
    name: "Laura B.",
    initials: "LB",
    role: "Assistenza",
    quote:
      "Assistenza via WhatsApp fantastica. Mi hanno aiutato a identificare il codice esatto del ricambio che mi serviva in pochi minuti. Gentili, competenti e sempre pronti a risolvere i dubbi.",
  },
];

export const STATS = [
  { value: "12", label: "Mesi di garanzia", suffix: "" },
  { value: "35", label: "Anni di esperienza", suffix: "+" },
  { value: "24", label: "Ore per preventivo", suffix: "h" },
  { value: "100", label: "Spedizioni in Italia", suffix: "%" },
];

export const TICKER = [
  "MOTORI USATI",
  "CAMBI MANUALI",
  "CAMBI AUTOMATICI",
  "MUSATE COMPLETE",
  "REVISIONATI",
  "BANCO PROVA",
  "GARANZIA 12 MESI",
  "SPEDIZIONI ITALIA",
];

export const BRANDS = [
  "AUDI",
  "BMW",
  "MERCEDES",
  "VOLKSWAGEN",
  "FIAT",
  "ALFA ROMEO",
  "FORD",
  "OPEL",
  "PEUGEOT",
  "RENAULT",
  "CITROEN",
  "TOYOTA",
];
